import ValidationInterface from "@/plans/common/validation-interface";
import {
  bizPlusCategories,
  eduPlusCategories,
  meetingCategories,
  proPlusCategories,
  SDKCategories,
  SDKUCCategories, USCallingCategories,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [this.current(proPlusCategories).require(["ZVP", "ZVC"], { billingCycleEqual: true, licenseMatch: false })];
  }

  async conflicts() {
    return [
      ...this.current(proPlusCategories).conflict([...meetingCategories, ...bizPlusCategories, ...eduPlusCategories, ...SDKCategories, ...SDKUCCategories]),
      ...this.current(proPlusCategories).conflict(USCallingCategories),
    ];
  }
}
